import { type PropsWithChildren } from "react";
import { type FeatureConfig, defaultFeatureConfig } from "./FeatureConfig";
import { useConfigureFeatures } from "./internal/useConfigureFeatures";
import { FeatureContext } from "./useFeatureConfig";

export function FeatureProvider(props: PropsWithChildren<{}>) {
  const featureConfig = useConfigureFeatures();

  return (
    <FeatureContext value={featureConfig}>{props.children}</FeatureContext>
  );
}

export function StaticFeatureProvider(
  props: PropsWithChildren<{ featureConfig?: Partial<FeatureConfig> }>,
) {
  return (
    <FeatureContext value={{ ...defaultFeatureConfig, ...props.featureConfig }}>
      {props.children}
    </FeatureContext>
  );
}
